import { gql } from "@apollo/client";

export const GET_EXPORT_FRECUENCIA_DISTRIBUIDOR = gql`
query GetExportFrecuenciaDistribuidor{
    exportFrecuenciaDistribuidor
    {
        idFrecuenciaDistribuidor,
        idProveedorDistribuidor,
        kilometroDestino,
        costoEntregaInmediata,
        idDeposito,
        activo,
        idProveedorDistribuidorNavigation {
            idProveedorDistribuidor,
            razonSocial
        },
        idDepositoNavigation {
            idDeposito,
            descripcion
        },
        idFrecuenciaModoDespachoNavigation {
            idFrecuenciaModoDespacho,
            descripcion
        },
        frecuenciaDistribuidorCP{
            idFrecuenciaDistribuidorCP,
            idCodigoPostal,
            idCodigoPostalNavigation {
                idCodigoPostal,
                cP,
                idProvincia,
                localidad,
                idProvinciaNavigation {
                    idProvincia,
                    descripcion
                }
            }
        }
    }
}`;